<template lang="pug">
div
	page-header(:title='title', :url='url', :titleNew='titleNew')
	.row
		.col-md-3
			select-form(v-model='filtro.empresa', :value='filtro.empresa', name='Empresa', :url='`/empresas?ativo=1&empresa_id=${user.empresa_id}`', id='titulo', titulo='titulo')
		.col-md-2
			label Patrimônio
			money.form-control.col-xs-10.col-sm-3(v-bind="patrimonio", v-model='filtro.patrimonio' placeholder="Patrimônio" maxlength="7")
		.col-md-3
			label Equipamento
			input.form-control.col-xs-10.col-sm-3(placeholder="Equipamento" type="text" v-model="filtro.equipamento")
		.col-md-3
		.col-md-1
			br
			button.btn.btn-primary(@click.prevent='getLimparFiltro') Limpar
	br

	grid(
		class="gridequi"
		:url='urlDataSource'
		:columns='columns'
		:GridHeight="400"
		:GridPageable="true"
		:DSpageSize="8"
		:DSserverPaging="true"
		:DSschema="true"
		:DSschemaData="'data'"
		:DSschemaTotal="'total'"
		:DSschemaParse="parse"
		:GridPageablePageSizes="[1, 10, 20, 100]"
		:DSfilter="filter",
		:DSserverFiltering="true",
		:toolbar="[{ name: 'excel', text: 'Exportar Excel', iconClass: 'k-icon k-i-excel' }]",
		:excelFileName="excelFileName",
        :excelFilterable="true",
        :excelAllPages="true",
	)
</template>

<script>
import Vue from 'vue'
import PageHeader from '@/components/PageHeader'
import Grid from '@/components/Grid'

import GridTemplate from '@/mixins/GridTemplate'
import Permission from '@/mixins/Permission'

import SelectForm from '@/components/form/SelectForm'
import { Money } from 'v-money'
import jwt from 'jwt-simple'
import JSZip from 'jszip'
import moment from 'moment'
window.JSZip = JSZip


export default {
	mixins: [GridTemplate, Permission],
	components: {
		PageHeader,
		Grid,
		SelectForm,
		Money,
	},
	computed: {
		filter() {
			return {
				logic: 'and',
				filters: [
					{
						field: 'empresa',
						operator: 'contains',
						value: this.filtro.empresa
					},
					{
						field: 'patrimonio',
						operator: 'contains',
						value: this.filtro.patrimonio
					},
					{
						field: 'equipamento',
						operator: 'contains',
						value: this.filtro.equipamento
					}
				]
			}
		},
		urlDataSource() {
			return `${this.$url}/equipamentos?all&empresa_id=${this.user.empresa_id}`
		}
	},
	data() {
		return {
			title: 'Equipamentos',
			titleNew: '',
			url: '/sistema/equipamentos/',
			//urlDataSource: ,
			columns: [
				{
					field: 'empresa_nome',
					title: 'Empresa',
					width: 120,
					locked: true
				},
				{
					field: 'patrimonio',
					title: 'Patrimonio',
					width: 120,
					locked: true
				},
				{
					field: 'equipamento',
					title: 'Equipamento',
					width: 400,
					locked: true
				},
				{
					field: 'modelo',
					title: 'Modelo',
					width: 60,
					locked: true
				},
				{
					field: 'marca',
					title: 'Marca',
					width: 100
				},
				{
					field: 'voltagem_nome',
					title: 'Nº de Série',
					width: 60
				},
				{
					field: 'referencia',
					title: 'Voltagem',
					width: 120
				},
				{
					field: 'fornecedor',
					title: 'Fornecedor',
					width: 120
				},
				{
					field: 'valor_compra',
					title: 'Valor da compra (R$)',
					width: 100
				},
				{
					field: 'valor_locacao',
					title: 'Valor da locação (R$)',
					width: 100
				},
				{
					field: 'nota_fiscal',
					title: 'Nº nota fiscal',
					width: 100
				},
				{
					field: 'aquisicao',
					title: 'Data aquisição',
					width: 100
				},
				{
					field: 'situacao_af',
					title: 'Situação da aferição',
					width: 100
				},
				{
					field: 'ultima_af',
					title: 'Última aferição',
					width: 100
				},
				{
					field: 'proxima_af',
					title: 'Próxima aferição',
					width: 100
				},
				{
					field: 'verificacao',
					title: 'Verificação',
					width: 100
				},
				{
					field: 'prox_verificacao',
					title: 'Próxima verificação',
					width: 100
				},
				{
					field: 'cal_data',
					title: 'Calibração Data',
					width: 100
				},
				{
					field: 'cal_laudo',
					title: 'Número do laudo',
					width: 100
				},
				{
					field: 'status_situacao',
					title: 'Situação do equipamento',
					width: 100
				},
				{
					field: 'status_nome',
					title: 'Condições',
					width: 100
				},
				{
					field: 'obs',
					title: 'Observação',
					width: 100
				},
				{
					field: 'cidade',
					title: 'Cidade',
					width: 140
				},
				{
					field: 'obra',
					title: 'Obra',
					width: 140
				},
				{
					template: this.linkTemplate,
					title: 'Link',
					width: 105,
					locked: true
				}
			],
			filtro: {
				empresa: null,
				patrimonio: null,
				equipamento: null,
			},
			patrimonio: {
				decimal: '',
				thousands: '',
				prefix: '',
				suffix: '',
				precision: 5,
				masked: true
			},
			user: {},
			excelFileName: `siS-${Math.random().toString(36).substring(7)}.xlsx`
		}
	},
	methods: {
		parse(d) {
			d.data.map(i => {
				// eslint-disable-next-line use-isnan
				i.valor_compra = i.valor_compra == 'NaN' ? '0' : i.valor_compra
				i.valor_locacao = i.valor_locacao == 'NaN' ? '0' : i.valor_locacao
				i.ultima_af = i.ultima_af ? moment(i.ultima_af).format('DD/MM/YYYY') : ''
				i.proxima_af = i.proxima_af ? moment(i.proxima_af).format('DD/MM/YYYY') : ''
				i.prox_verificacao = i.prox_verificacao ? moment(i.prox_verificacao).format('DD/MM/YYYY') : ''
				i.cal_data = i.cal_data ? moment(i.cal_data).format('DD/MM/YYYY') : ''
				i.aquisicao = i.aquisicao ? moment(i.aquisicao).format('DD/MM/YYYY') : ''
				return i
			})
			return d
		},
		verifPermissao() {
			this.titleNew = this.ACTION.c ? 'Novo' : ''
			if (this.ACTION.e) {
				this.columns.push({
					field: 'ativo',
					title: 'Ações',
					width: 105,
					template: this.commandTemplate,
					exportableExcel: false,
					locked: true
				})
			}
		},
		getLimparFiltro() {
			let filtro = {
				empresa: null,
				patrimonio: null,
				equipamento: null,
			}
			localStorage.setItem('_filtroEquipamento', JSON.stringify(filtro))
			this.filtro = filtro
		},
		linkTemplate(e) {
			return {
				template: Vue.component('temp', {
					template: `
                <div>
                <a class="btn btn-secundary btn-sm" :href='url(templateArgs.patrimonio, templateArgs.empresa_id)' @click.prevent="buttonClick(templateArgs.patrimonio, templateArgs.empresa_id)">
                  <i class="fa fa-link" aria-hidden="true"></i> Abrir
                </a>
                </div>
            `,
					data() {
						return {
							templateArgs: {}
						}
					},
					methods: {
						url(id, empresa) {
							return `/ver/${id}/${empresa}`
						},
						buttonClick(id, empresa) {
							window.open(`/ver/${id}/${empresa}`, '_blank')
						}
					}
				}),
				templateArgs: e
			}
		},
	},
	created() {
		let user = localStorage.getItem('user')
		if (user) {
			this.user = JSON.parse(jwt.decode(user, 'vox'))
		}
		this.verifPermissao()
	},
	mounted() {
		let filtro = localStorage.getItem('_filtroEquipamento')
			? JSON.parse(localStorage.getItem('_filtroEquipamento'))
			: null
		if (filtro) {
			this.filtro = filtro
		}
	}
}
</script>

<style lang="scss">
.gridequi {
	.k-grid td {
	height: 50px;
}
}

</style>
